import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  TextField, Button, Box, IconButton 
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';

interface NewFeatureRequestDialogProps {
  open: boolean;
  onClose: () => void;
  newRequest: {
    title: string;
    description: string;
  };
  setNewRequest: React.Dispatch<React.SetStateAction<{
    title: string;
    description: string;
  }>>;
  onSubmit: () => void;
}

const NewFeatureRequestDialog: React.FC<NewFeatureRequestDialogProps> = ({
  open,
  onClose,
  newRequest,
  setNewRequest,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <FormattedMessage id="featureRequests.newRequest" />
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={intl.formatMessage({ id: "featureRequests.form.title" })}
          fullWidth
          variant="outlined"
          value={newRequest.title}
          onChange={(e) => setNewRequest({...newRequest, title: e.target.value})}
        />
        <TextField
          margin="dense"
          label={intl.formatMessage({ id: "featureRequests.form.description" })}
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={newRequest.description}
          onChange={(e) => setNewRequest({...newRequest, description: e.target.value})}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          <FormattedMessage id="common.cancel" />
        </Button>
        <Button onClick={onSubmit} color="primary" variant="contained">
          <FormattedMessage id="common.submit" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewFeatureRequestDialog;